import React from "react";
import {
  Dropdown,
  Option,
  useId,
  makeStyles,
} from "@fluentui/react-components";
import { FluentField } from "./Fluent-Field";
import PropTypes from "prop-types";
import "./fluent-overide.scss";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    fontWeight: 600,
    textAlign: "left",
    width: "100%",
    color: "#4E4E4E",

    "& button:disabled": {
      backgroundColor: "#f3f2f1",
      color: "#242424",
    },
  },
});

export const FluentDropdownOptionAsObject = ({
  label,
  disabled,
  validationMessage,
  required,
  size,
  placeholder,
  defaultValue,
  options,
  onChange,
  componentStyle,
  selectedOptions,
  value,
  isControlled = false,
  labelStyle
}) => {
  const dropdownId = useId("dropdown-default");
  const fieldStyle = useStyles();
  const combinedStyles = componentStyle || fieldStyle.root;
  if (isControlled) {
    return (
      <FluentField
        label={label}
        size={size}
        validationMessage={validationMessage}
        required={required}
        componentStyle={labelStyle}
      >
        <Dropdown
          aria-labelledby={dropdownId}
          placeholder={placeholder}
          onOptionSelect={onChange}
          value={value}
          disabled={disabled}
          className={combinedStyles}
          selectedOptions={selectedOptions}
        >
          {options?.map((option) => (
            <Option key={option?.id} value={option?.id} text={option?.name}>
              {option?.name}
            </Option>
          ))}
        </Dropdown>
      </FluentField>
    );
  } else {
    return (
      <FluentField
        label={label}
        size={size}
        validationMessage={validationMessage}
        required={required}
      >
        <Dropdown
          aria-labelledby={dropdownId}
          placeholder={placeholder}
          onOptionSelect={onChange}
          defaultValue={defaultValue}
          defaultSelectedOptions={[defaultValue]}
          disabled={disabled}
          className={combinedStyles}
        >
          {options?.map((option) => (
            <Option key={option?.id} value={option?.id} text={option?.name}>
              {option?.name}
            </Option>
          ))}
        </Dropdown>
      </FluentField>
    );
  }
};

FluentDropdownOptionAsObject.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  validationMessage: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  componentStyle: PropTypes.string,
  size: PropTypes.string,
  selectedOptions: PropTypes.array,
  value: PropTypes.string,
  isControlled: PropTypes.bool,
  labelStyle: PropTypes.string,
};
